<template>
    <ui-modal id="add-responsible" title="Alterar Responsável" title-text="Selecione outro responsável por este ticket" size="xs">
        <div class="users-select">
            <ul>
                <li v-for="(user) in users" :key="user.id">
                    <ui-user-check :data="user.id" :name="user.name" :role="user.role_name" :avatar="user.metas.avatar" v-model="form.owner_id" />
                </li>
            </ul>
        </div>
        <div class="control-form">
            <button type="submit" @click="save">Salvar alterações</button>
        </div>
    </ui-modal>
</template>

<script>
    import { uiModal, uiUserCheck } from '@/components'
    import { tickets, user, configurations } from '@/services'
    import { textareaResize } from '@/directives'
    export default {
        components: { uiModal, uiUserCheck },
        directives: { textareaResize },
        data() {
            return {
                users: [],
                form: {
                    owner_id: null,
                },
                owner_role: null,
            }
        },
        props: {
            ticket: {}
        },
        computed: {
            indicator(){
                return this.load ? 'load' : ''
            },
        },
        watch:{
            ticket: function(ticket){
                this.form.owner_id = this.ticket.owner_id
                return ticket
            }
        },
        methods: {
            getConfigs(){
                configurations.list().then( response => {
                    this.owner_role = response.data.tickets_users_owners
                    this.getUsers()
                })
            },
            getUsers(){
                user.list("/?roles=" + this.owner_role).then( response => {
                    this.users = response.data
                })
            },
            save(){
                tickets.setOwner(this.ticket.id, this.form).then( response => {
                    response.data.row.index = this.ticket.index
                    this.$root.$emit('update-item', response.data.row);
                })
            }
        },
        created(){
            
            this.getConfigs()
            
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
